export default {
  en: {
    incentive: 'Incentive',
    metric: 'Metric',
    scoring: 'Scoring',
    commsHub: 'CommsHub',

    // CustomIncentive.vue
    addCustomIncentive: 'ADD CUSTOM INCENTIVE',
    maxIncentivesPerBU: 'Maximum of 5 incentives per business unit',
    incentiveSavedSuccess: 'Incentive saved successfully!',
    incentiveDeletedSuccess: 'Incentive deleted successfully!',
    incentiveSaveFailed: 'Failed to save incentive. Please try again.',
    incentiveDeleteFailed: 'Failed to delete incentive. Please try again.',
    incentiveApprovedSuccess: 'Incentive approved successfully!',
    incentiveApproveFailed: 'Failed to approve incentive. Please try again.',

    // wizard.vue
    editCustomIncentive: 'Edit Custom Incentive',
    addCustomIncentiveTitle: 'Add Custom Incentive',
    basicInfo: 'Basic Info',
    metrics: 'Metrics',
    weighting: 'Weighting',
    additionalInfo: 'Additional Info',
    previewAndSubmit: 'Preview & Submit',
    cancel: 'Cancel',
    saveAndClose: 'Save & Close',
    configureStep: 'Configure {step}',

    // BasicInfo.vue
    businessUnit: 'Business Unit',
    incentiveName: 'Incentive Name',
    startDate: 'Start Date',
    endDate: 'End Date',
    addPracticeStartDate: 'Add Practice Start Date',
    practiceStartDate: 'Practice Start Date',
    displayEndDate: 'Display End Date',
    practiceTooltip:
      'BU can show an incentive early for "practice weeks,"\nwhen incentive is visible to restaurants but do not\ncount toward final results until the official start date',
    displayEndTooltip:
      "The last day this incentive will be shown on TV slide\n(to keep Crew Members up-to-date). Scoring stops\non the incentive's actual end date, not the display end date.",
    incentiveNameRequired: 'Incentive name is required',
    incentiveNameInvalid:
      "Only letters, numbers, $, %, and ' symbols are allowed",
    acceptCurrentConfiguration: 'Accept current configuration',

    // Metrics.vue
    selectMetricsDescription:
      'Select the metrics and timeslices for your new incentive',
    addMetric: 'Add Metric',
    maxMetricsReached: 'Maximum of 5 metrics reached',

    // MetricRow.vue
    selectMetric: 'Select Metric',
    selectTimeslice: 'Select Timeslice',

    // ScoringRules.vue
    configureMetricsFirst:
      'Configure Metrics in the previous step to enable Scoring Rules.',
    decideWeighing: 'Decide the weighing of each metric',
    mustTotal100: '(must total 100%)',
    weightValidationError:
      'Total desired weights must add up to 100%. Current total: {total}%',

    // Notes.vue
    notesPlaceholder:
      'List any relevant information. Please be aware that anything you enter here will be displayed to anyone with access to the MYQ Homepage for operators.',
    acceptCurrentNotes: 'Accept current notes',

    // PointCalcs.vue
    desiredWeight: 'Desired Weight (%)',

    // IncentivePreview.vue
    incentiveNameLabel: 'Incentive Name',
    unnamedIncentive: 'Unnamed Incentive',
    dates: 'Dates',
    metricsSection: 'Metrics',
    name: 'Name',
    timeslice: 'Timeslice',
    weight: 'Weight',
    createdBy: 'Created By',
    author: 'Author',
    createdDate: 'Created Date',
    notes: 'Notes',
    na: 'N/A',

    // IncentiveTable.vue
    customIncentives: 'Custom Incentives',
    kpis: 'KPIs',
    status: 'Status',
    approvedBy: 'Approved By',
    actions: 'Actions',
    edit: 'Edit',
    delete: 'Delete',
    confirmDelete: 'Confirm Delete',
    confirmDeleteMessage: 'Are you sure you want to delete',
    statusLive: 'Live',
    statusPracticeMode: 'Practice Mode',
    statusAwaitingApproval: 'Awaiting Approval',
    statusScheduled: 'Scheduled',
    statusCompleted: 'Completed',
    statusArchived: 'Archived',
    statusScheduledTooltip:
      'Approved and waiting for practice period to begin',
    statusCompletedTooltip: 'Results still visible to crew',
    statusArchivedTooltip: 'Fully finished, results no longer visible',

    // ApprovalDialog.vue
    approved: 'Approved',
    needsApproval: 'Needs Approval',
    approve: 'Approve',
    view: 'View',
    customIncentiveDetails: 'Custom Incentive Details',
    close: 'Close',

    // ExampleWidget.vue
    timeframe: 'Timeframe',
    week: 'Week {n}',
    customIncentive: 'Custom Incentive',
    nsn: 'NSN',
    overallRank: 'Overall Rank',
    points: '(points)',
    totalPoints: 'Total Points',
    incentivePreview: 'Incentive Preview',
  },
  es: {
    incentive: 'Incentivo',
    metric: 'Métrica',
    scoring: 'Puntuación',
    commsHub: 'CommsHub',

    // CustomIncentive.vue
    addCustomIncentive: 'AGREGAR INCENTIVO PERSONALIZADO',
    maxIncentivesPerBU:
      'Máximo de 5 incentivos por unidad de negocio',
    incentiveSavedSuccess: '¡Incentivo guardado exitosamente!',
    incentiveDeletedSuccess: '¡Incentivo eliminado exitosamente!',
    incentiveSaveFailed:
      'Error al guardar el incentivo. Por favor, inténtelo de nuevo.',
    incentiveDeleteFailed:
      'Error al eliminar el incentivo. Por favor, inténtelo de nuevo.',
    incentiveApprovedSuccess: '¡Incentivo aprobado exitosamente!',
    incentiveApproveFailed:
      'Error al aprobar el incentivo. Por favor, inténtelo de nuevo.',

    // wizard.vue
    editCustomIncentive: 'Editar Incentivo Personalizado',
    addCustomIncentiveTitle: 'Agregar Incentivo Personalizado',
    basicInfo: 'Información Básica',
    metrics: 'Métricas',
    weighting: 'Ponderación',
    additionalInfo: 'Información Adicional',
    previewAndSubmit: 'Vista Previa y Enviar',
    cancel: 'Cancelar',
    saveAndClose: 'Guardar y Cerrar',
    configureStep: 'Configurar {step}',

    // BasicInfo.vue
    businessUnit: 'Unidad de Negocio',
    incentiveName: 'Nombre del Incentivo',
    startDate: 'Fecha de Inicio',
    endDate: 'Fecha de Fin',
    addPracticeStartDate: 'Agregar Fecha de Inicio de Práctica',
    practiceStartDate: 'Fecha de Inicio de Práctica',
    displayEndDate: 'Fecha de Fin de Visualización',
    practiceTooltip:
      'La UN puede mostrar un incentivo anticipadamente para "semanas de práctica",\ncuando el incentivo es visible para los restaurantes pero no\ncuenta para los resultados finales hasta la fecha de inicio oficial',
    displayEndTooltip:
      'El último día que este incentivo se mostrará en la diapositiva de TV\n(para mantener a los miembros del equipo actualizados). La puntuación se detiene\nen la fecha de fin real del incentivo, no en la fecha de fin de visualización.',
    incentiveNameRequired: 'El nombre del incentivo es requerido',
    incentiveNameInvalid:
      'Solo se permiten letras, números y los símbolos $, % y \'',
    acceptCurrentConfiguration: 'Aceptar configuración actual',

    // Metrics.vue
    selectMetricsDescription:
      'Seleccione las métricas y franjas horarias para su nuevo incentivo',
    addMetric: 'Agregar Métrica',
    maxMetricsReached: 'Máximo de 5 métricas alcanzado',

    // MetricRow.vue
    selectMetric: 'Seleccionar Métrica',
    selectTimeslice: 'Seleccionar Franja Horaria',

    // ScoringRules.vue
    configureMetricsFirst:
      'Configure las Métricas en el paso anterior para habilitar las Reglas de Puntuación.',
    decideWeighing: 'Decida la ponderación de cada métrica',
    mustTotal100: '(debe sumar 100%)',
    weightValidationError:
      'Los pesos deseados deben sumar 100%. Total actual: {total}%',

    // Notes.vue
    notesPlaceholder:
      'Incluya cualquier información relevante. Tenga en cuenta que todo lo que ingrese aquí se mostrará a cualquier persona con acceso a la página de inicio de MYQ para operadores.',
    acceptCurrentNotes: 'Aceptar notas actuales',

    // PointCalcs.vue
    desiredWeight: 'Peso Deseado (%)',

    // IncentivePreview.vue
    incentiveNameLabel: 'Nombre del Incentivo',
    unnamedIncentive: 'Incentivo Sin Nombre',
    dates: 'Fechas',
    metricsSection: 'Métricas',
    name: 'Nombre',
    timeslice: 'Franja Horaria',
    weight: 'Peso',
    createdBy: 'Creado Por',
    author: 'Autor',
    createdDate: 'Fecha de Creación',
    notes: 'Notas',
    na: 'N/D',

    // IncentiveTable.vue
    customIncentives: 'Incentivos Personalizados',
    kpis: 'KPIs',
    status: 'Estado',
    approvedBy: 'Aprobado Por',
    actions: 'Acciones',
    edit: 'Editar',
    delete: 'Eliminar',
    confirmDelete: 'Confirmar Eliminación',
    confirmDeleteMessage: '¿Está seguro de que desea eliminar',
    statusLive: 'Activo',
    statusPracticeMode: 'Modo de Práctica',
    statusAwaitingApproval: 'Esperando Aprobación',
    statusScheduled: 'Programado',
    statusCompleted: 'Completado',
    statusArchived: 'Archivado',
    statusScheduledTooltip:
      'Aprobado y esperando que comience el período de práctica',
    statusCompletedTooltip: 'Resultados aún visibles para el equipo',
    statusArchivedTooltip:
      'Completamente finalizado, resultados ya no visibles',

    // ApprovalDialog.vue
    approved: 'Aprobado',
    needsApproval: 'Necesita Aprobación',
    approve: 'Aprobar',
    view: 'Ver',
    customIncentiveDetails: 'Detalles del Incentivo Personalizado',
    close: 'Cerrar',

    // ExampleWidget.vue
    timeframe: 'Período',
    week: 'Semana {n}',
    customIncentive: 'Incentivo Personalizado',
    nsn: 'NSN',
    overallRank: 'Rango General',
    points: '(puntos)',
    totalPoints: 'Puntos Totales',
    incentivePreview: 'Vista Previa del Incentivo',
  },
};
